import { createFileRoute } from '@tanstack/react-router';
import { ObjectivesPage } from '#features/objectives/objectives-page';

export const Route = createFileRoute('/_authed/objectives')({ component: ObjectivesPage });
